import {
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT
} from "../../state/modules/layout";

const isSiteCoreMedia = mediaUrl =>
  mediaUrl.startsWith("https://content.asos-media.com/");

const mobilePosterUrlTemplateFactory = (featuredHeaderData, urlParams) =>
  isSiteCoreMedia(featuredHeaderData.app.imageUrl)
    ? featuredHeaderData.app.imageUrl
    : `${featuredHeaderData.app.imageUrl}${urlParams}`;

const desktopPosterUrlTemplateFactory = (featuredHeaderData, urlParams) =>
  isSiteCoreMedia(featuredHeaderData.web.imageUrl)
    ? featuredHeaderData.web.imageUrl
    : `${featuredHeaderData.web.imageUrl}${urlParams}`;

const VIEWPORT_CATEGORY_TO_POSTER_URL_TEMPLATE_FACTORY_MAP = {
  [SMALL_VIEWPORT]: mobilePosterUrlTemplateFactory,
  [MEDIUM_VIEWPORT]: desktopPosterUrlTemplateFactory,
  [LARGE_VIEWPORT]: desktopPosterUrlTemplateFactory
};

const VIEWPORT_CATEGORY_TO_POSTER_URL_PARAMS_FACTORY_MAP = {
  [SMALL_VIEWPORT]: "?$n_480w$&wid=476&fit=constrain",
  [MEDIUM_VIEWPORT]: "?$n_750w$&wid=750&fit=constrain",
  [LARGE_VIEWPORT]: "?$n_1920w$&wid=1926&fit=constrain"
};

export const generatePosterUrl = (viewportCategory, featuredHeaderData) => {
  const urlParams =
    VIEWPORT_CATEGORY_TO_POSTER_URL_PARAMS_FACTORY_MAP[viewportCategory];

  return `${VIEWPORT_CATEGORY_TO_POSTER_URL_TEMPLATE_FACTORY_MAP[
    viewportCategory
  ](featuredHeaderData, urlParams)}`;
};
